import { useQuery, useQueryClient } from "@tanstack/react-query";
import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { FLAGS_LIST_QUERY_KEY } from "../utils/queryKeys";
import { getFlags, Flag } from "../api/flags";

export function useFlags() {
  const pathname = usePathname();
  const queryClient = useQueryClient();

  useEffect(() => {
    queryClient.invalidateQueries({ queryKey: [FLAGS_LIST_QUERY_KEY] });
  }, [pathname, queryClient]);

  return useQuery<Record<string, Flag>>({
    queryKey: [FLAGS_LIST_QUERY_KEY],
    queryFn: getFlags,
    staleTime: 1000 * 60 * 2,
    gcTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    refetchOnReconnect: true,
  });
}
